intra_module.directive('studentInfos', function() {
	return {
		restrict:    'E',
		templateUrl: 'directives/widget/student-infos/template.html',
		controller:  'StudentInfosCtrl',
		replace:     true,

		scope: {
			user: '='
		}
	};
});
